<template>
  <el-dialog width="800px" class="dialog" :title="title" :visible="visible" @close="closeFun">
    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>

    <el-checkbox-group v-model="checkedOptions" @change="handleCheckedOptionsChange">
      <div v-for="item in options">
        <div class="opt-tit">
          <el-checkbox class="tit-checkbox" :key="item.props" disabled>{{ item.label }}</el-checkbox>
        </div>
        <el-row :gutter="20" type="flex" class="row-flex">
          <el-col :span="6" v-for="itemChild in item.children" :key="itemChild.field">
            <el-checkbox :label="itemChild.field" :key="itemChild.field">{{ itemChild.chinese }}</el-checkbox>
          </el-col>
        </el-row>
      </div>
    </el-checkbox-group>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeFun">取 消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="confirmFun">确认导出</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { error } from 'shelljs'

export default {
  props: {
    // title 标题
    title: {
      type: String,
      default: '导出'
    }
  },
  data() {
    return {
      /**
       * visible 弹框显示
       * btnLoading 按钮loading
       * checkAll 是否全选
       * isIndeterminate 是否半选
       */
      visible: false,
      btnLoading: false,
      checkAll: false,
      isIndeterminate: false,
      mapOptions: {
        appointmentInfo: '预约信息',
        evaluationInfo: '评价信息',
        orderInfo: '订单信息',
        productInfo: '商品信息',
        recommendInfo: '推荐信息',
        recycleInfo: '回收信息',
        indicatorInfo: '指标信息'
      },
      options: [],
      checkedOptions: []
    }
  },
  methods: {
    // 打开弹窗
    /**
     *
     * @param exportPropType 导出选项类型
     * 1 用户
     * 2 批量
     */
    openFun(exportPropType) {
      this.exportPropType = exportPropType
      if (this.exportPropType) {
        this.getOptionsProp()
      }
      this.visible = true
    },
    // 获取导出选项并勾选内容
    getOptionsProp() {
      const url = `/autoapp-default-server-recovery/api/tblRecycleOrder/getExportField?userType=${this.exportPropType}`
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          const resDataObj = res.data
          this.originResData = JSON.parse(JSON.stringify(resDataObj))
          const newOptions = []
          const defCheckedOptions = []
          for (const key in resDataObj) {
            if (key != 'type') {
              const item = {
                props: key,
                label: this.mapOptions[key] || key,
                children: resDataObj[key]
              }
              newOptions.push(item)
              // 勾选默认选中的内容
              resDataObj[key].forEach(itemChild => {
                if (itemChild.select == 1) {
                  defCheckedOptions.push(itemChild.field)
                }
              })
            }
          }
          this.options = newOptions
          this.checkedOptions = defCheckedOptions
          this.isIndeterminate = defCheckedOptions.length > 0 && defCheckedOptions.length < this.getAllFields(newOptions).length
          const allOptionsVal = this.getAllFields(this.options)
          this.checkAll = defCheckedOptions.length === allOptionsVal.length
        }
      })
    },
    // 关闭弹窗
    closeFun() {
      this.visible = false
    },
    getAllFields(data) {
      return data.reduce((acc, curr) => {
        return acc.concat(curr.children.map(item => item.field))
      }, [])
    },
    handleCheckAllChange(val) {
      const allOptionsVal = this.getAllFields(this.options)
      this.checkedOptions = val ? allOptionsVal : []
      this.isIndeterminate = false
    },
    handleCheckedOptionsChange(value) {
      const checkedCount = value.length
      const allOptionsVal = this.getAllFields(this.options)
      this.checkAll = checkedCount === allOptionsVal.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < allOptionsVal.length
    },
    // 确认保存
    confirmFun() {
      for (const key in this.originResData) {
        if (key != 'type') {
          this.originResData[key].forEach(item => {
            item.select = this.checkedOptions.includes(item.field) ? 1 : 0
          })
        }
      }
      this.saveSubmitPropExportFun()
    },
    // 保存导出的属性数据请求
    saveSubmitPropExportFun() {
      this.btnLoading = true
      const url = `/autoapp-default-server-recovery/api/tblRecycleOrder/saveExportField`
      const params = {
        ...this.originResData
      }
      this.HttpService.post(url, params).then(
        res => {
          this.btnLoading = false
          if (res.statusCode === 200) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.$emit('confirm-export', this.checkedOptions)
            this.closeFun()
          } else {
            const errorMsg = res.message || '保存失败'
            this.$message.error(errorMsg)
          }
        },
        error => {
          this.btnLoading = false
        }
      )
    }
  }
}
</script>
<style scoped lang="scss">
.dialog {
  .dialog-footer {
    padding: 20px 60px;
  }
  .opt-tit {
    padding: 15px 0px;
    box-sizing: border-box;
  }
}
.tit-checkbox /deep/.el-checkbox__input {
  opacity: 0;
  display: none;
}
.tit-checkbox /deep/.el-checkbox__label {
  font-weight: bold;
  color: #333 !important;
}
.tit-checkbox /deep/.el-checkbox__input.is-disabled + span.el-checkbox__label {
  cursor: pointer;
}

.row-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/ExportPropDialog.vue